import * as React from "react";
import ImageView from "../../../components/SmartImage";
import { CardBannerContainer } from "./styles";
import { TBannerItem } from "../../../services/banner";
import { LinkTargetType, TModuleWithImgProps } from "../../../services/playground";
import { isNotBlankArray } from "utils/array";
import { transformAParam } from "utils/browser";
import { formatBannerGridSize } from "views/utils/banner";

const ANIMATION_DURATION = 1000;

export interface CardBannerProps extends TModuleWithImgProps {
	cardBanners: Array<TBannerItem>;
}

interface CardBannerState {
	cIndex: number;
	animationDuration: number;
}

class CardBanner extends React.Component<CardBannerProps, CardBannerState> {
	state: CardBannerState = {
		cIndex: 2,
		animationDuration: 0,
	};

	autoSwipe: boolean = true;
	canClick: boolean = true;
	countDown: any = 0;

	componentDidMount() {
		this.autoScroll();
	}

	componentWillUnmount() {
		this.stopAutoScroll();
	}

	autoScroll() {
		clearTimeout(this.countDown);
		this.countDown = setTimeout(() => {
			if (this.autoSwipe && document.visibilityState === "visible") {
				this.onNext();
			}
			this.autoScroll();
		}, 4000);
	}

	stopAutoScroll() {
		clearTimeout(this.countDown);
	}

	getStyle = () => {
		const bannerWidth = 435;
		const { cIndex, animationDuration } = this.state;
		const style: React.CSSProperties = {};
		const wrapperOffsetLeft = -bannerWidth * cIndex;

		style.width = `${this.getNodeCount}00%`;
		style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
		style.transitionDuration = `${animationDuration}ms`;
		style.WebkitTransform = style.transform;
		style.transitionTimingFunction = "ease-out";

		return style;
	};

	get getNodeCount() {
		const { cardBanners } = this.props;
		return cardBanners.length + 4;
	}

	onNext = () => {
		if (!this.canClick) {
			return;
		}
		this.canClick = false;
		this.setState((state) => ({
			cIndex: state.cIndex + 1,
			animationDuration: ANIMATION_DURATION,
		}));
	};

	onBack = () => {
		if (!this.canClick) {
			return;
		}
		this.canClick = false;
		this.setState((state) => ({
			cIndex: state.cIndex - 1,
			animationDuration: ANIMATION_DURATION,
		}));
	};

	onTransitionEnd = () => {
		if (this.state.cIndex > this.props.cardBanners.length) {
			this.setState({
				cIndex: 1,
				animationDuration: 0,
			});
		}
		if (!this.state.cIndex) {
			this.setState({
				cIndex: this.props.cardBanners.length,
				animationDuration: 0,
			});
		}
		this.canClick = true;
	};

	renderCardBanner = (img: string, link: string, index: number) => {
		const { placeholderBg } = this.props;
		const aProps = transformAParam({
			isInApp: false,
			link,
			aTarget: LinkTargetType.Blank,
		});
		return (
			<li key={index}>
				<a data-href={link} {...aProps}>
					<ImageView
						src={img}
						aliSize={4.2}
						qnParams={{ w: 420 }}
						isLazyLoad={false}
						online={this.props.online}
						placeholder={placeholderBg}
						fallbackSrc={placeholderBg}
					/>
				</a>
			</li>
		);
	};

	render() {
		const { cardBanners, positionId, style = {}, minWidth = 0, width = "0" } = this.props;
		if (!isNotBlankArray(cardBanners)) {
			return null;
		}
		const banner = cardBanners[0];
		const { width: gridWidth, aspectRatio } = formatBannerGridSize(
			banner,
			Math.max(+width, minWidth),
		);

		return (
			<CardBannerContainer
				id={positionId}
				onMouseEnter={() => (this.autoSwipe = false)}
				onMouseLeave={() => (this.autoSwipe = true)}
				gridWidth={+gridWidth}
				gridHeight={banner.width ? aspectRatio * 420 : 0}
				style={{
					...style,
				}}
			>
				<div className={"leftArrow"} onClick={this.onBack} />
				<ul
					className={"scrollContainer"}
					style={this.getStyle()}
					onTransitionEnd={this.onTransitionEnd}
				>
					{cardBanners
						.slice(-2)
						.map((item, index: number) =>
							this.renderCardBanner(item.img, item.link, index),
						)}
					{cardBanners.map((item, index: number) =>
						this.renderCardBanner(item.img, item.link, index),
					)}
					{cardBanners
						.slice(0, 2)
						.map((item, index: number) =>
							this.renderCardBanner(item.img, item.link, index),
						)}
				</ul>
				<div className={"rightArrow"} onClick={this.onNext} />
			</CardBannerContainer>
		);
	}
}

export default CardBanner;
